import React from 'react'
import './style.scss'

const Row = ({ children, normal, ...props }) => {
  const style = {}
  if (normal) {
    style.width = `${100 / (React.Children.toArray(children).length || 1)}%`
  }
  return (
    <div className="row" {...props}>
      {React.Children.map(children, (child, index, array) =>
        React.cloneElement(child, { ...(child.props || {}), style }))}
    </div>
  )
}

export default Row
